"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var book_1 = require("common/domain/book");
var React = require("react");
var react_redux_1 = require("react-redux");
var books_1 = require("../redux/books");
var BookDetails_1 = require("./BookDetails");
var Button_1 = require("./Button");
var ItemLike_1 = require("./ItemLike");
var ItemName_1 = require("./ItemName");
require("./style/SimpleBook.css");
var SimpleBook = /** @class */ (function (_super) {
    __extends(SimpleBook, _super);
    function SimpleBook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleBook.prototype.render = function () {
        var _a = this.props, addToTodoList = _a.addToTodoList, name = _a.name, url = _a.url;
        var book = book_1.extractBook(this.props);
        return (React.createElement(ItemLike_1.default, { className: "SimpleBook-container" },
            React.createElement(ItemName_1.default, { href: url, text: name }),
            React.createElement(BookDetails_1.default, __assign({ detailed: false }, book)),
            React.createElement(Button_1.default, { onClick: function () { return addToTodoList(book); } }, "Add to to-read list")));
    };
    return SimpleBook;
}(React.Component));
exports.default = react_redux_1.connect(null, books_1.actionCreators)(SimpleBook);



//////////////////
// WEBPACK FOOTER
// ./src/component/SimpleBook.tsx
// module id = 626
// module chunks = 0